<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="equipmentItemForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="equipmentItem" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                equipmentItemForm: () => import('../forms/EquipmentItemForm'),
                equipmentItem: () => import('../editViews/EquipmentItem'),
                headers: [
                    { text: 'Facility', value: 'facilityId', table: 'facilities', form: () => import('../forms/FacilityForm') },
                    { text: 'Name', value: 'name' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    facilities: [],
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                    { column: "facilityId", direction: "ascending" },
                ],
                itemsField: 'equipmentItems',
                editPageName: 'equipmentItem',
                apiMethod: 'EquipmentItems',
                claimName: 'EquipmentItems',
                formTitle: 'Equipment Item',
                excelTitle: 'Equipment Items',
                hasEditPage: true,
            }
        },
    };
</script>
